module.exports = __webpack_public_path__ + "img/articleCongePaternite.81e5a7ac.png";